import Equipment from '../../models/Equipment';
import { ROUTES } from '../../../../config/routes';
import translations from './locales';

const xdi32 = new Equipment({
  id: 'xdi32',
  name: 'XDI32',
  displayName: { main: 'XDI32' },
  path: ROUTES.xdi32Intro,
  assetDirectory: '/Equipment/xdi32',
  translations,
  image: { file: 'machine.png', width: 1536, height: 1024 },
  video: null,
  catalog: {
    fallbackLanguage: 'en',
    files: { ko: 'catalog.png', en: 'catalog-en.png', zh: 'catalog-zh.png' },
  },
  badges: [
    { id: 'diameter', valueKey: 'diameterTag' },
    { id: 'spindle', value: '6,500 rpm' },
  ],
  metrics: [
    { id: 'diameter', labelKey: 'specifications.maxDiameter.label', value: 'Ø32', unit: 'mm' },
    { id: 'spindle', labelKey: 'specifications.mainSpindle.label', value: '6,500', unit: 'rpm' },
    { id: 'stroke', labelKey: 'hStroke', value: '350', unit: 'mm' },
    { id: 'cross', labelKey: 'crossPower', value: '2.2', unit: 'kW' },
  ],
  features: ['simultaneous', 'balanced', 'backTools'],
  specifications: [
    { id: 'nc', value: 'Fanuc 31iB' },
    { id: 'maxDiameter', value: 'Ø32 mm' },
    { id: 'z1Stroke', value: '350 mm (H) / 100 mm (N)' },
    { id: 'mainSpindle', value: '6,500 rpm · 2.2 / 5.5 kW' },
    { id: 'turningTools', value: '7 × (□16 mm) · 4 + 3' },
    { id: 'frontTools' },
    { id: 'crossTools' },
    { id: 'crossSpeed', value: '6,000 rpm / 2.2 kW' },
    { id: 'bAxisTools' },
    { id: 'bAxisSpeed', value: '6,000 rpm / 1.0 kW' },
    { id: 'subSpindle', value: '6,500 rpm · 2.2 / 5.5 kW' },
    { id: 'backTools' },
    { id: 'backSpeed', value: '6,000 rpm / 1.0 kW' },
    { id: 'dimensions', value: '2,910 × 1,710 × 2,010 mm' },
    { id: 'weight', value: '6,300 kg' },
    { id: 'power' },
    { id: 'air', value: '120–150 L/min' },
  ],
  specificationNoteKey: 'specificationNote',
  options: ['crossUnit', 'bAxis', 'backCross', 'gunDrill'],
  optionImages: {
    crossUnit: 'crossUnit.png',
    bAxis: 'bAxis-catalog.png',
    backCross: 'backCross.png',
    gunDrill: 'gunDrill.png',
  },
});

export default xdi32;
